<template>
  <section class="content-categories-default">
    <Breadcrumb :links="links"/>
    <div class="content-categories-default-body">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="category in blogCategories" :key="category.id">
          <CardCategory :category="category" :isType="'Blog'"/>
        </div>
      </div>
    </div>
    <ModalDelete/>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardCategory from '@/components/cards/CardCategory';
import ModalDelete from '@/components/modals/ModalDelete';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Blog',
          routerName: 'Blog'
        },
        {
          name: 'Categorias',
          routerName: 'ListBlogCategories'
        },
      ],
    }
  },
  components: {
    Breadcrumb,
    CardCategory,
    ModalDelete
  },
  computed: {
    ...mapGetters('Blog', ['blogCategories'])
  },
  methods: {
    ...mapActions('Blog', ['consultCategoriesBlog', 'registerCategoryBlog'])
  },
  mounted() {
    this.consultCategoriesBlog();
  }
}
</script>

<style lang="scss">
</style>
